const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

const envApiUrl = process.env.REACT_APP_API_URL?.trim();
const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";

if (process.env.NODE_ENV === "production" && !envApiUrl && browserOrigin) {
  console.warn("REACT_APP_API_URL is not set. Falling back to current origin.");
}

const defaultApiUrl =
  process.env.NODE_ENV === "production" && browserOrigin
    ? browserOrigin
    : "http://localhost:5000";

export const API_URL = trimTrailingSlash(envApiUrl || defaultApiUrl);

